import { render, staticRenderFns } from "./CompactChip.vue?vue&type=template&id=1f43848c&scoped=true"
import script from "./CompactChip.vue?vue&type=script&lang=js"
export * from "./CompactChip.vue?vue&type=script&lang=js"
import style0 from "./CompactChip.vue?vue&type=style&index=0&id=1f43848c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f43848c",
  null
  
)

export default component.exports